/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q1Inputs */

const en_pc_faq_q1 = /** @type {(inputs: Pc_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PdfCraft really free?`)
};

const zh_pc_faq_q1 = /** @type {(inputs: Pc_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 真的免费吗？`)
};

/**
* | output |
* | --- |
* | "Is PdfCraft really free?" |
*
* @param {Pc_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q1 = /** @type {((inputs?: Pc_Faq_Q1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q1(inputs)
	return zh_pc_faq_q1(inputs)
});
export { pc_faq_q1 as "pc.faq.q1" }